import { createStore, TYPE } from 'dop'
import { CONNECTION, LOGIN, VIEW, LOCALSTORAGE } from '~/const'
import {
    getLocale,
    localStorageGet,
    localStorageSet,
    localStorageRemove,
    changeRoute,
    isWeb,
} from '~/utils/device'

export const store = createStore(getDefaultState())

export function getDefaultState(patch = {}, replace = false) {
    const web3 = {
        error: null,
        open: false,
        loaded: false,
        wallets: [],
        wallet: null,
        addresses: [],
        address: null,
        coin: null,
        payment: null,
    }

    const user = {
        _id: null,
        username: null,
        icon: null,
        trophies: 0,
        xp: 0,
        level: 0,
        percent: 0,
        coins: 0,
        tulips: 0,
        rewards: {},
        status: {},
        invited: null,
    }

    return {
        view: VIEW.HOME,
        viewback: null,
        connection: CONNECTION.CLOSE,
        login: LOGIN.AUTOLOGIN,
        input: null,
        language: getLocale(),
        sounds: true,
        music: true,
        game_id: null,
        profile_id: null,
        outdated: null,
        playerror: null,
        user: replace ? TYPE.Replace(user) : user,
        web3: replace ? TYPE.Replace(web3) : web3,

        ...patch,
    }
}

export function getGlobalState() {
    return store.state
}

export function setGlobalState(patch) {
    store
        .applyPatch(patch)
        .filter(({ mutations }) => mutations.length > 0)
        .forEach(({ listener, patch }) => listener(patch))
}

const ROUTES = {
    [VIEW.HOME]: () => `/`,
    [VIEW.GAME]: ({ game_id }) => `/livegame/${game_id}`,
}

export function changeView(view, params = { viewback: null }) {
    setGlobalState({ view, ...params })
    if (ROUTES.hasOwnProperty(view)) {
        changeRoute(ROUTES[view](params))
    }
}

export function openWeb3(params = {}) {
    setGlobalState({
        web3: {
            open: true,
            error: null,
            payment: null,
            ...params,
        },
    })
}

// Logic
// Logic
// Logic

export function onServerPatch(patch) {
    // console.log(patch)
    // setTimeout(() => {
    setGlobalState({ user: patch })
    // }, 1000)
}

export async function onLogout(Server) {
    localStorageRemove(LOCALSTORAGE.EMAIL)
    localStorageRemove(LOCALSTORAGE.TOKEN)
    setGlobalState({
        login: LOGIN.NOTLOGED,
        view: VIEW.HOME,
        email: null,
        token: null,
        connection: store.state.connection,
    })
    Server.userLogout({})
}

export function setSounds(value) {
    setGlobalState({ sounds: value })
    localStorageSet(LOCALSTORAGE.SOUNDS, value)
}

export function setMusic(value) {
    setGlobalState({ music: value })
    localStorageSet(LOCALSTORAGE.MUSIC, value)
}

// Load route
;(async function () {
    if (isWeb()) {
        const livegame = /(livegame)\/([a-zA-Z0-9]+)/gm.exec(location.pathname)
        if (livegame !== null) {
            const [, , game_id] = livegame
            changeView(VIEW.GAME, { game_id })
        }
    }
})()

// Load localStorage
;(async () => {
    const { state } = store
    const email = await localStorageGet(LOCALSTORAGE.EMAIL)
    const token = await localStorageGet(LOCALSTORAGE.TOKEN)
    const language = await localStorageGet(
        LOCALSTORAGE.LANGUAGE,
        state.language
    )
    const sounds = await localStorageGet(LOCALSTORAGE.SOUNDS, state.sounds)
    const music = await localStorageGet(LOCALSTORAGE.MUSIC, state.music)

    const patch = {
        email,
        token,
        language,
        sounds,
        music,
    }

    setGlobalState(patch)
})()
